import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as utils from '../../shared/helpers/utils';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  exceptions = ['.s3.'];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const auth = utils?.localStorageGetItem('auth');

    if (!this.exceptions.some(url => request.url.includes(url))) {
      // if ((request.url.includes('login') && (request.url.includes('api.360depict') || request.url.includes('api.fits'))) || !request.url.includes('login')) {
      
      if (auth?.accessToken && !request.url.includes(environment.cognitoUrl)) {
        request = request.clone({
          setHeaders: {
            authorization: auth.accessToken
          }
        });
      } else {
        request = request.clone({
          setHeaders: {
            authorization: 'gM87QkxPWyrJJcVJ'
          }
        });
      }
    }

    return next.handle(request);
  }

}
